import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ck3ocbab9u: FaireBrandEntity = {
  token: "b_ck3ocbab9u",
  type: "brand",
  name: "The Fox and The Mermaid",
  avatarUrl:
    "https://cdn.faire.com/fastly/e6d9cabb1ee3d183d39c64311547b922bf0dd814c02dc2445dd35b31fc451f74.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1b6cc91cb7d1087d6b5ebc163fe6bd5be27f80e02effea3c7afb0e84d482a976.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e6d9cabb1ee3d183d39c64311547b922bf0dd814c02dc2445dd35b31fc451f74.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1b6cc91cb7d1087d6b5ebc163fe6bd5be27f80e02effea3c7afb0e84d482a976.jpeg",
  location: "Venice, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 127,
  isTopShop: true,
  isInsider: true,
  description:
    "The Fox and the Mermaid specializes in hand block printed, artisan-made clothing and accessories. Our fabrics are created using carved wood blocks dipped in pigments, a 2,000 year-old tradition passed down through families by skilled artisans from generation to generation. This slow, intricate process uses no electricity and cannot be mass-produced, making each piece truly unique. As of 2023, in an effort to empower Indian women in what is still a very patriarchal\nsociety, The Fox and the Mermaid has chosen to exclusively partner with women-owned and women-run factories.\n\nAbout Me: My name is Brianna. After an 18-year career as a television producer, I followed my passion for design and travel to create a brand rooted in age old\ncraftsmanship. Four years ago, I moved from California to Puerto Vallarta, Mexico, where I live full-time. Life between the jungle and the ocean inspires me daily andcontinues to influence the colors, textures, and spirit of my collections.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:31.416Z",
    importedBy: "entity-db-cli",
  },
};
